import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import _ from "lodash";
import socket from "../../../../context/socket";
import YearSelect from "../../StartedYear/year";
import { fetchClientData } from "../../../../redux/client/clientSlice";
import { useDispatch } from "react-redux";
import api from "../../../../utils/api";

// Debounce function to delay API calls
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

const LoanPrepaymentData = ({ roomId, card_id, planYourGoals }) => {
  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(null);
  const [loanPrepaymentInputData, setLoanPrepaymentInputData] = useState({
    amount: "",
    goalYear: "",
    startYear: new Date().getFullYear().toString(),
  });

  // Fetch the selected card and set the initial data


  useEffect(() => {
    if (planYourGoals && card_id) {
      const card = planYourGoals.find((item) => item._id === card_id);
      // console.log('card',card);

      setSelectedCard(card);

      // If action_data exists, map it to retirementInputData
      if (card?.action_data?.[0]) {
        const {
          amount = "",
          goalYear = "",
          startYear,
        } = card.action_data[0];

        setLoanPrepaymentInputData({
          amount,
          goalYear,
          startYear: startYear || new Date().getFullYear().toString(),
        });
      } else {
        // ✅ Fallback when no action_data at all
        setLoanPrepaymentInputData((prev) => ({
          ...prev,
          startYear: new Date().getFullYear().toString(),
        }));
      }
    }
  }, [planYourGoals, card_id]);

  // Function to save data via API
  const saveData = async (updatedData) => {
    // Check if all required fields are filled
    const allFieldsFilled =
      updatedData.amount !== "" &&
      updatedData.goalYear !== "" &&
      updatedData.startYear !== "";

    // Add the status field based on whether all fields are filled
    // const dataWithStatus = {
    //   ...updatedData,
    //   status: allFieldsFilled ? 1 : 0, // Status is 1 if all fields are filled, otherwise 0
    // };

      const newStatus = allFieldsFilled ? 1 : 0;
      const prevCreatedAt = selectedCard?.created_at;

      const dataWithStatus = {
        ...updatedData,
        status: newStatus,
      };

      const payload = {
        _id: roomId,
        dream_id: card_id,
        action_data: [dataWithStatus],
        status: newStatus,
      };

      // ✅ Add created_at ONLY ONCE at ROOT
      if (newStatus === 1 && !prevCreatedAt) {
        payload.created_at = new Date().toISOString();
      }

    try {
      const response = await api.post(`advisor/save_goal_data`,payload);
      dispatch(fetchClientData(roomId));

      console.log("Data saved successfully:", response.data);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };


  // Debounced save function
  const debouncedSaveData = useCallback(
    debounce((updatedData) => saveData(updatedData), 500),
    [selectedCard]
  );

  // Handle input changes
  const handleLoanPrepaymentInputChange = (field, value) => {
    const updatedData = {
      ...loanPrepaymentInputData,
      [field]: value,
    };
    setLoanPrepaymentInputData(updatedData);

    // Trigger the debounced save function
    debouncedSaveData(updatedData);
  };

  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      console.log("emitted data", selectedCard,);
      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
          loanPrepaymentInputData,
        },
      });
    }, 300),
    [
      selectedCard,
      roomId,
      loanPrepaymentInputData,
    ]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [
    selectedCard,
    debouncedEmitMessage,
    loanPrepaymentInputData,
  ]);

  return (
    <>
      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            I plan to prepay{" "}
            <span className="clrgreen fw-semibold">
              <input
                type="number"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${loanPrepaymentInputData.amount?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "7ch",
                }}
                className="clrgreen fw-bold ps-3 moinput"
                value={loanPrepaymentInputData.amount}
                // onChange={(e) =>
                //   handleLoanPrepaymentInputChange("amount", e.target.value)
                // }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleLoanPrepaymentInputChange("amount", value)
                  }
                }}
                placeholder="0"
              />
            </span>{" "}
            <span>of my home loan by the year</span>
            <input
              type="text"
              style={{
                border: "none",
                borderBottom: "1px solid green",
                width: `${loanPrepaymentInputData.goalYear?.length + 3}ch`,
                paddingLeft: "1rem",
                minWidth: "8ch",
              }}
              value={loanPrepaymentInputData.goalYear}
              // onChange={(e) =>
              //   handleLoanPrepaymentInputChange("goalYear", e.target.value)
              // }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  handleLoanPrepaymentInputChange("goalYear", value)
                }
              }}
              className="clrgreen fw-bold ps-3 moinput"
              placeholder="Year"
            />.
          </p>
        </div>
      </div>

      {/* <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            Start Year{" "}
            <span className="clrgreen fw-semibold">
              <select
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${loanPrepaymentInputData.startYear?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "8ch",
                }}
                className="clrgreen fw-bold ps-3 moinput"
                value={loanPrepaymentInputData.startYear}
                onChange={(e) =>
                  handleLoanPrepaymentInputChange("startYear", e.target.value)
                }
              >
                <option value="">Select</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
              </select>
            </span>{" "}
          </p>
        </div>
      </div> */}

      <div className="row ps-3 align-items-center">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>

        <div className="col-md-9 col-10 d-flex align-items-center">
          <p className="fs-21 lh-sm me-2 pt-3">Start Year:</p>
          <div style={{ minWidth: "120px" }}>
            <YearSelect
              value={loanPrepaymentInputData.startYear}
              onChange={(val) => handleLoanPrepaymentInputChange("startYear", val)}
              recentYear={new Date().getFullYear()}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanPrepaymentData;
